import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';

import * as APIS from "../utils/service";
import { close, listupdater, loadingflas, open } from '../redux/popupSlice';
import { getBase64, getMemberinfo } from '../utils/utils';
import Radios from './Radios';


export default function AlertPopup(props) {

    const { 
        setbellshowflag = () => {},
        setproducttogethersendflag = () => {},
        setproducttogetherconfirmflag = () => {},
        setproductIdx = () => {}
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { listupdate } = useSelector(s => s.popupReducer);

    const [memberinfos, setmemberinfos] = useState(''); 

    const [page, setPage] = useState(0);   
    const [leaveoptionpop, setleaveoptionpop] = useState(false);   
    const [leaveoptionpopComment, setleaveoptionpopComment] = useState('OOO공인중개사사무소의 매물/고객 정보 귀속 설정이 변경되었으니 확인하세요.');   
    const [leaveoptionpopnextoption, setleaveoptionpopnextoption] = useState('OOO공인중개사사무소의 매물/고객 정보 귀속 설정이 변경되었으니 확인하세요.');   
    const [leaveoptionagree, setleaveoptionagree] = useState(0);   
    const [datas, setdata] = useState({});   
    
    const { configdata } = useSelector(s => s.configReducer);

    let leavelists = configdata?.consts?.leaveOptionConsts;
    let leavechData = [];
    leavelists?.map((x, i) => {
        leavechData.push({
            names: x?.title,
            comments: x?.desc,
            values: x?.idx,
        });
    });
    const [leaveOptionlist, setleaveOptionlist] = useState(leavechData);   



    const [activebelllist, setactivebelllist] = useState([]);   

    const [belllist, setbelllist] = useState([]);   
    //console.log(leavelists);
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        if(listupdate === true){
            dispatch(listupdater({ listupdate: false }));
            listopen();
        }
    }, [listupdate]);

    useEffect(() => {
        listopen();
        setPage(1);
        // observe(target.current);
    }, []);
    const listopen = () => {
        let sender = {
            rolling: false
        }
        APIS.postData('/v1/alarm/list', sender).then(({ data }) => {
            if(data){
                // data.sort(function (a, b) {
                //     if(a.hasOwnProperty('required')){
                //         return b.required - a.required;
                //     }
                // });
                // setlists(data);
                let importantlist = [];
                let normallist = [];
                data?.map((x, i) => {
                    if(x?.type*1 === 2){
                        importantlist.push(x);
                    } else {
                        normallist.push(x);
                    }
                });
                /*
                mediation - 공동중개
                leave_option - 귀속여부변경
                manager - 담당자변경
                schedule - 일정알림
                */
                setactivebelllist(importantlist);
                setbelllist(normallist);
                setdata(data);
                console.log(data);

            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
        });           
    }

    const AlertDelete = (didx) => {
        dispatch(loadingflas({ loading: true }));
        let sender = { idx: didx }
        APIS.postData('/v1/alarm/remove', sender).then(({ data }) => {
            if(data){
                listopen();
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }
    const leaveOptionSubmit = () => {
        
        let sender = { leave_option: leaveoptionagree*1 === 1 ? memberinfos?.leave_option*1 : leaveoptionpopnextoption*1 }
        dispatch(loadingflas({ loading: true }));
        APIS.postData('/v1/compony/leaveOptionUpdate', sender).then(({ data }) => {
            if(data){
                setleaveoptionpop(false);
                listopen();
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }
    return (
        <>
        {leaveoptionpop === true &&
        <div className='ProductDetailArea' style={{ zIndex: 1003}}>
            <div>
                <div className='ProductDetailAreaBG' 
                    // onClick={() => {
                    //     setleaveoptionpop(false);
                    // }}
                />

                <div></div>
                <div className="ProductSendDetailpop " style={{ width: 440 }}> 
                    <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee'}}>
                        <span>매물/고객정보 귀속 설정 변경 안내</span>
                        <button
                            onClick={() => {
                                setleaveoptionpop(false);
                            }}
                        >
                            <img src="./images/icons/x.svg" />                                            
                        </button>
                    </div>
                    <div 
                        className="mettingArea padding32"
                    >
                        <div className='texts' style={{ wordBreak: 'keep-all'}}>
                            {leaveoptionpopComment}
                        </div>
                        <div className='tips' style={{ backgroundColor: '#fff'}}>
                            <div className='fontsize16 bolds'>변경전</div>
                            <div className='tipcontents margint8'>
                                <p className='bolds'>{leaveOptionlist?.find(item => item?.values*1 === memberinfos?.leave_option*1)?.names}</p>
                            </div>
                            <div className='tipcontents margint8'>
                                <p>{leaveOptionlist?.find(item => item?.values*1 === memberinfos?.leave_option*1)?.comments}</p>
                            </div>
                        </div>

                        <div className='tips'>
                            <div className='fontsize16 bolds'>변경후</div>
                            <div className='tipcontents margint8'>
                                <p className='bolds'>{leaveOptionlist?.find(item => item?.values*1 === leaveoptionpopnextoption*1)?.names}</p>
                            </div>
                            <div className='tipcontents margint8'>
                                <p>{leaveOptionlist?.find(item => item?.values*1 === leaveoptionpopnextoption*1)?.comments}</p>
                            </div>
                        </div>
                        <div>
                            <Radios
                                linetype={'checkimg'}
                                values={leaveoptionagree}
                                setvalues={setleaveoptionagree}
                                namevalue={[
                                    {names: '동의함', values: 0},
                                    {names: '비동의', values: 1},
                                ]}
                            /> 
                        </div>
                        
                        <div className='popbuttons' style={{ width: '100%', marginTop: 0 }}>
                            <div>
                                <Button
                                    disabled={true}
                                    buttonTxt={'취소'}
                                    onPress={() => { setleaveoptionpop(false); }}
                                />                                    
                            </div>
                            <div>
                                <Button
                                    buttonTxt={'확인'}
                                    onPress={() => { 
                                        leaveOptionSubmit();
                                    }}
                                />                                    
                            </div>
                        </div>
                                           
                    </div>
                </div>
                <div></div>
            </div>
        </div>       } 
        <div className='AlertPopArea'>
            <div>
                <div className='AlertPopAreaBG' 
                    onClick={() => { setbellshowflag(false) }}
                />
                <div className="AlertPoplistArea" style={{ height: 'calc(100% - 100px)', overflow: 'auto'}}>
                    <div className="titleTxt">알림</div>
                    <div className="subtitleTxt active">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M16.667 14.167H18.3337V15.8337H1.66699V14.167H3.33366V8.33366C3.33366 4.65176 6.31843 1.66699 10.0003 1.66699C13.6822 1.66699 16.667 4.65176 16.667 8.33366V14.167ZM15.0003 14.167V8.33366C15.0003 5.57223 12.7617 3.33366 10.0003 3.33366C7.2389 3.33366 5.00033 5.57223 5.00033 8.33366V14.167H15.0003ZM7.50033 17.5003H12.5003V19.167H7.50033V17.5003Z" fill="#FF0000"/>
                            </svg>
                            <span>중요 알림</span>
                        </div>
                        <button type="button" onClick={() => {
                            dispatch(
                                open({
                                    component: '삭제하시겠습니까?',
                                    title: '삭제하기',
                                    button: "삭제",
                                    buttonCencle: "닫기",       
                                    titleviewer: true,                 
                                    alert: false,
                                    onPress: () => {
                                        dispatch(loadingflas({ loading: true }));
                                        let sender = {
                                            type: 2,
                                        }
                                        APIS.postData('/v1/alarm/removeAll', sender).then(({ data }) => {
                                            if(data){
                                                listopen();
                                                dispatch(
                                                    open({
                                                        component: `삭제되었습니다.`,
                                                        title: '알림',
                                                        titleviewer: true,
                                                        alert: false,
                                                        button: "확인",
                                                        onPress: () => {
                                                            dispatch(close());
                                                        }
                                                    })
                                                ); 
                                            }
                                        }).catch(({ response }) => {
                                            const { data } = response;
                                        }).finally(() => {
                                            dispatch(loadingflas({ loading: false }));
                                        }); 
                                    },
                                    onCancelPress: () => {
                                        dispatch(close());
                                    }
                                })
                            );  
                        }}>
                            전체삭제
                        </button>
                    </div>
                    <div className='bell_listArea'>
                        {activebelllist?.length > 0 && activebelllist?.map((x, i) => {
                            if(i > (page*3)){
                                return;
                            }
                            return (
                                <div key={i}>
                                    <div>
                                        <span>{moment(x?.create_dt).format('YYYY.MM.DD HH:mm')}</span>
                                        <button type="button" onClick={() => { AlertDelete(x?.idx); }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M10.0003 18.3337C5.39795 18.3337 1.66699 14.6027 1.66699 10.0003C1.66699 5.39795 5.39795 1.66699 10.0003 1.66699C14.6027 1.66699 18.3337 5.39795 18.3337 10.0003C18.3337 14.6027 14.6027 18.3337 10.0003 18.3337ZM10.0003 16.667C13.6822 16.667 16.667 13.6822 16.667 10.0003C16.667 6.31843 13.6822 3.33366 10.0003 3.33366C6.31843 3.33366 3.33366 6.31843 3.33366 10.0003C3.33366 13.6822 6.31843 16.667 10.0003 16.667ZM10.0003 8.82183L12.3573 6.46479L13.5358 7.6433L11.1788 10.0003L13.5358 12.3573L12.3573 13.5358L10.0003 11.1788L7.6433 13.5358L6.46479 12.3573L8.82183 10.0003L6.46479 7.6433L7.6433 6.46479L10.0003 8.82183Z" fill="#999999"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <div className='comments'
                                        style={{ cursor: 'pointer'}}
                                        onClick={() => {
                                            if(x?.url){
                                                window.open(x?.url);
                                            }
                                        }}                                       
                                    >
                                        {x?.desc}
                                        {x?.detail?.key === 'leave_option' &&
                                        <div className='alertPoptypebuttons'>
                                            <button type="button" onClick={() => {
                                                setleaveoptionpop(true);
                                                setleaveoptionpopComment(x?.desc);
                                                setleaveoptionpopnextoption(x?.detail?.next);
                                            }}>
                                                확인하기
                                            </button>
                                        </div>
                                        }
                                    </div>

                                </div>
                            );
                        })}
                        {activebelllist?.length === 0 &&
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                중요 알림이 없습니다.
                            </div>
                        }
                    </div>
                    <div className="bellmoreButtons margint20" style={{ width: 80 }}>
                        <Button
                            buttonTxt={'더보기'}
                            className={'linenormalbutton'}
                            styles={{ height: 32, fontSize: 12 }}
                            onPress={() => {
                                setPage((page) => page + 1);
                            }}                             
                        />                     
                    </div>

                    <div className="subtitleTxt margint20">
                        <div>
                            <span>일반 알림</span>
                        </div>
                        <button type="button" onClick={() => {
                            dispatch(
                                open({
                                    component: '삭제하시겠습니까?',
                                    title: '삭제하기',
                                    button: "삭제",
                                    buttonCencle: "닫기",       
                                    titleviewer: true,                 
                                    alert: false,
                                    onPress: () => {
                                        dispatch(loadingflas({ loading: true }));
                                        let sender = {
                                            type: 1,
                                        }
                                        APIS.postData('/v1/alarm/removeAll', sender).then(({ data }) => {
                                            if(data){
                                                listopen();
                                                dispatch(
                                                    open({
                                                        component: `삭제되었습니다.`,
                                                        title: '알림',
                                                        titleviewer: true,
                                                        alert: false,
                                                        button: "확인",
                                                        onPress: () => {
                                                            dispatch(close());
                                                        }
                                                    })
                                                ); 
                                            }
                                        }).catch(({ response }) => {
                                            const { data } = response;
                                        }).finally(() => {
                                            dispatch(loadingflas({ loading: false }));
                                        }); 
                                    },
                                    onCancelPress: () => {
                                        dispatch(close());
                                    }
                                })
                            );  
                        }}>
                            전체삭제
                        </button>
                    </div>
                    <div className='bell_listArea' style={{ marginBottom: 20 }}>
                        {belllist?.length > 0 && belllist?.map((x, i) => {
                            console.log(x);
                            return (
                                <div 
                                    key={i}
                                    style={{ cursor: 'pointer' }}

                                >
                                    <div>
                                        <span>{moment(x?.create_dt).format('YYYY.MM.DD HH:mm')}</span>
                                        <button type="button" onClick={() => { AlertDelete(x?.idx); }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M10.0003 18.3337C5.39795 18.3337 1.66699 14.6027 1.66699 10.0003C1.66699 5.39795 5.39795 1.66699 10.0003 1.66699C14.6027 1.66699 18.3337 5.39795 18.3337 10.0003C18.3337 14.6027 14.6027 18.3337 10.0003 18.3337ZM10.0003 16.667C13.6822 16.667 16.667 13.6822 16.667 10.0003C16.667 6.31843 13.6822 3.33366 10.0003 3.33366C6.31843 3.33366 3.33366 6.31843 3.33366 10.0003C3.33366 13.6822 6.31843 16.667 10.0003 16.667ZM10.0003 8.82183L12.3573 6.46479L13.5358 7.6433L11.1788 10.0003L13.5358 12.3573L12.3573 13.5358L10.0003 11.1788L7.6433 13.5358L6.46479 12.3573L8.82183 10.0003L6.46479 7.6433L7.6433 6.46479L10.0003 8.82183Z" fill="#999999"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <div className='comments'
                                        onClick={() => {
                                            
                                            if(x?.detail?.key === 'mediation'){
                                                //setbellshowflag(false);
                                                setproductIdx(x?.detail?.idx);
                                                setproducttogethersendflag(true);
                                            }
                                            if(x?.detail?.key === 'mediationconfirm'){
                                                //console.log(x);
                                                setbellshowflag(false);
                                                // setproductIdx(x?.detail?.idx);
                                                // setproducttogetherconfirmflag(true);
                                                //navigate("/Product", {state: { itemIdx: x?.detail?.idx }});
                                                let sender = { idx: x?.detail?.idx }
                                                APIS.postData('/v1/mediation/get', sender).then(({ data }) => {
                                                    if(data){
                                                        const { item, customer, mediation } = data;
                                                        navigate("/Product", {state: { itemIdx: item?.idx }});
                                                    }
                                                }).catch(({ response }) => {
                                                    const { data } = response;
                                                }).finally(() => {
                                                });   
                                                
                                            }
                                            if(x?.detail?.key === 'review'){
                                                //setbellshowflag(false);
                                                navigate("/ReviewPage", {state: { review: x }});
                                            }
                                            if(x?.url){
                                                window.open(x?.url);
                                            }
                                        }}                                    
                                    >
                                        {x?.title !== null &&
                                            <div className='alerPoptypestickers'>
                                                <span>{x?.title}</span>
                                            </div>
                                        }                                              
                                        {x?.desc}
                                    </div>
                                </div>
                            );
                        })}
                        {belllist?.length === 0 &&
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                일반 알림이 없습니다.
                            </div>
                        }
                    </div>
                </div>                
            </div>
        </div>
        </>
    )    
}